(() => {
  const examplesEnabled = !matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-predictive-search]').forEach(shell => {
    const input = shell.querySelector('input[name="q"]');
    const results = shell.querySelector('.studio-search-results');
    const endpoint = shell.dataset.endpoint;
    if (!input || !results || !endpoint) return;
    let timer;
    let request;
    let exampleIndex = 0;
    const examples = (shell.dataset.examples || '').split('|').map(item => item.trim()).filter(Boolean);
    const close = () => { results.hidden = true; results.replaceChildren(); input.setAttribute('aria-expanded', 'false'); };
    const open = () => { results.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const addRow = (label, url, category) => {
      if (!url) return;
      const destination = new URL(url, location.origin);
      if (destination.origin !== location.origin) return;
      const a = document.createElement('a');
      a.href = destination.href;
      a.setAttribute('role', 'option');
      const caption = document.createElement('small');
      caption.textContent = category;
      const title = document.createElement('span');
      title.textContent = label;
      a.append(caption, title);
      results.append(a);
    };
    const search = async () => {
      const query = input.value.trim();
      if (query.length < 2) { close(); return; }
      request?.abort();
      request = new AbortController();
      try {
        const url = new URL(endpoint.replace(/\/$/, '') + '.json', location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product,page,article');
        url.searchParams.set('resources[limit]', '5');
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const payload = await response.json();
        if (input.value.trim() !== query) return;
        results.replaceChildren();
        const found = payload.resources?.results || {};
        (found.products || []).filter(item => item.handle !== 'pre-cut' && !(item.tags || []).includes('hidden') && !(item.tags || []).includes('kixxl-proxy-product') && !(item.tags || []).includes('gangsheet-addon')).forEach(item => addRow(item.title, item.url, 'Product'));
        (found.pages || []).forEach(item => addRow(item.title, item.url, 'Help page'));
        (found.articles || []).forEach(item => addRow(item.title, item.url, 'Guide'));
        const all = document.createElement('a');
        all.setAttribute('role', 'option');
        all.href = shell.querySelector('form').action + '?q=' + encodeURIComponent(query);
        all.textContent = 'See all results for “' + query + '” →';
        results.append(all);
        open();
      } catch (error) {
        if (error.name !== 'AbortError') close();
      }
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(search, 180); });
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2) search(); });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowDown' && !results.hidden) { event.preventDefault(); results.querySelector('a')?.focus(); }
    });
    results.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); input.focus(); }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const items = [...results.querySelectorAll('a')];
        const next = items.indexOf(document.activeElement) + (event.key === 'ArrowDown' ? 1 : -1);
        if (items[next]) { event.preventDefault(); items[next].focus(); }
      }
    });
    document.addEventListener('click', event => { if (!shell.contains(event.target)) close(); });
    if (examplesEnabled && examples.length > 1) setInterval(() => {
      if (document.activeElement === input || input.value || document.hidden) return;
      exampleIndex = (exampleIndex + 1) % examples.length;
      input.placeholder = 'Try “' + examples[exampleIndex] + '”';
    }, 3500);
  });
})();
